import routerOptions0 from "/home/runner/actions-runner/_work/myefficiency/myefficiency/frontend/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@types+node@22.9.0_@vue+compiler-sfc@3.5.26_cac@6.7.14_db0@_73763ntyii3wh53vbc7qqfabba/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}